import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslationService } from '../services/translation.service';

/**
 * HTTP Interceptor to add Accept-Language header to all requests
 *
 * This allows the backend to return localized error messages and content
 * in the user's preferred language.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translationService = inject(TranslationService);
  const currentLanguage = translationService.getCurrentLanguage();

  // Add Accept-Language header with current locale
  // Format: en-US, es-MX, etc.
  const modifiedReq = req.clone({
    headers: req.headers.set('Accept-Language', currentLanguage)
  });

  return next(modifiedReq);
};
